import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";
import Multitessere from "../../pages/Multitessere";

function AcquaFitAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="" style={{fontFamily: "Hammersmith One"}}></th>
                                    <th scope="col" style={{width: "30%"}}>
                                        3 mesi
                                    </th>
                                    <th scope="col" style={{width: "30%"}}>
                                        6 mesi
                                    </th>
                                    <th scope="col" style={{width: "30%"}}>
                                        Stagionale
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Monosettimanale</th>
                                    <td className={"data-cell"}>243 €</td>
                                    <td className={"data-cell"}>372 €</td>
                                    <td className={"data-cell"}>474 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">Bisettimanale</th>
                                    <td className={"data-cell"}>303 €</td>
                                    <td className={"data-cell"}>444 €</td>
                                    <td className={"data-cell"}>588 €</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <AllertIscrizione />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AcquaFitAccordionPrezzi